import { PtLuxonDate } from '../projects/date.models';
import { DateTime } from 'luxon';

export interface DailyLegLoadPerLeg {
  legNumber: number;
  load: number;
}

export class DailyLegLoad {
  id?: number;
  localId?: number;

  disabled: boolean;
  status: DailyLegLoadStatus;
  statusId: number;

  date: DateTime;
  timeShow: string;
  timeOffset: number;

  isStandalone: boolean;

  legs: DailyLegLoadPerLeg[] = [];

  port: number;
  fore: number;

  calculatedElevatedWeight: number;
  measuredElevatedWeight: number;

  comment: string;

  totalMinutesElevatedOnDate: number;
  totalTimeElevatedOnDateShow: string;
  totalMinutesElevatedAtLocation: number;
  totalTimeElevatedAtLocationShow: string;
}

export enum DailyLegLoadStatus {
  NotComplete = 1,
  InProgress = 2,
  Complete = 3
}

export class DailyLegLoadCompleteEditor {
  date: DateTime;
  isComplete: boolean;
}

export class DailyLegLoadCompleteFilters {
  date: DateTime;
}

export class DailyLegLoadStandaloneEditor {
  dailyLegLoadId: number;
  readingTime: PtLuxonDate;
  readingTimeOffset: number;
  readingTimeShow: string;
}

export class DailyLegLoadFrequencyEditor {
  id: number;
  jackUpOperationId: number;

  effectiveFromDate: PtLuxonDate;
  effectiveFromDateOffset: number;
  effectiveFromDateShow: string;

  observationStartTimeSeconds: number;
  observationStartTimeShow: string;

  observationEndTimeSeconds: number;
  observationEndTimeShow: string;

  frequencySeconds: number;
  frequencyShow: string;
  defaultFrequencyShow: string;
  canDelete: boolean;
  projectName: string;
  phaseName: string;
  stageName: string;
}

export class DailyLegLoadFrequencyFilters {
  date?: DateTime;
}

export class DailyLegLoadGraphFilters {
  date?: DateTime;
  startDate?: DateTime;
  endDate?: DateTime;
}

export class DailyLegLoadExtensionFilters {
  date?: DateTime;
}

export interface DailyLegLoadGraphSeries {
  legNumber: number;
  data: number[];
}

export class DailyLegLoadGraphModel {
  dateTimeLabels: string[];
  series: DailyLegLoadGraphSeries[];
}

export class DailyLegLoadGraphLegDataModel {
  reading: number;
  date: DateTime;
}

export class DailyLegLoadExtensionModel {
  date: DateTime;
  legs: DailyLegLoadExtensionPerLeg[] = [];
}
export interface DailyLegLoadExtensionPerLeg {
  legNumber: number;
  totalExtension: number;
}



// WEBPACK FOOTER //
// ./src/models/daily-leg-loads/daily-leg-load.models.ts